<p>{{ fieldLabel }}</p>
<ng-container *ngIf="form.get(fieldName) as f">
  <div
    *ngFor="let choice of choices; let i = index"
    [ngClass]="{
            'form-check form-check-inline': !block,
            'form-check': block,
            'is-invalid': f.invalid
        }"
  >
    <input
      *ngIf="!readonlyField; else readonlyInput"
      class="form-check-input"
      type="radio"
      [formControl]="f | toFormControl"
      [class.is-invalid]="f.errors"
      [name]="fieldName"
      id="{{ fieldName }}_{{ instanceId }}_{{ i }}"
      [value]="choice.value"
    />
    <ng-template #readonlyInput>
      <input
        class="form-check-input"
        type="radio"
        [formControl]="f | toFormControl"
        [class.is-invalid]="f.errors"
        [name]="fieldName"
        [attr.disabled]="true"
        [value]="choice.value"
      />
    </ng-template>
    <label class="form-check-label" for="{{ fieldName }}_{{ instanceId }}_{{ i }}">&nbsp;{{ choice.key }}</label>
  </div>
  <div
    *ngIf="!f.disabled && !readonlyField && isDevMode()"
    [ngClass]="{
            'form-check form-check-inline': !block,
            'form-check': block
        }"
  >
    <em class="clear d-none" (click)="clear()">&times;</em>
  </div>
  <field-warnings [hidden]="f.disabled" [warnings]="warnings"></field-warnings>
  <div field-errors [control]="f"></div>
</ng-container>
